import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

const MaskLine = ({ children, delay }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-8% 0px" });
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={inView ? { y: 0 } : { y: "112%" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const MaskText = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <MaskLine key={i} delay={delay + i * 0.12}>
        <span className={lineClassName}>{line}</span>
      </MaskLine>
    ))}
  </span>
);

export const FadeIn = ({ children, className = "", delay = 0, y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ index, label }) => (
  <FadeIn className="flex items-center gap-4" y={16}>
    <span className="whitespace-nowrap font-display text-ember text-xl leading-none tracking-wide">{index}</span>
    <span className="h-px w-12 bg-ember/70" />
    <span className="font-body text-xs font-medium uppercase tracking-[0.35em] text-ash">{label}</span>
  </FadeIn>
);
